import { t } from "i18next";
import { useState } from "react";

const DocumentTypeForm = ({ documentDetails, onCloseModal, onSelectOption, dir }) => {
  
  const [selectedRow, setSelectedRow] = useState(null);

  console.log(documentDetails, "documentDetails");
  const handleShowResponse = () => {
    if (onCloseModal) {
      onSelectOption(documentDetails[selectedRow]);
      onCloseModal();
    }
  };
  const kioskWidth = window.innerWidth;
  const kioskHeight = window.innerHeight;
if (kioskWidth >= 1070 && kioskHeight >= 1800) {
    return (
    <div className="min-h-[35vh] bg-gray-50 flex justify-center items-center">
      <div className="w-full max-w-5xl p-6 rounded-lg">
        <h2 className="text-xl font-bold mb-8 text-center">
          {t("select_document")}
        </h2>
        <p className="text-center text-sm text-gray-500 mb-8">
         {t("select_deocument_desc")}
        </p>

        {/* Table */}
        {/* Table with scroll */}
        <div className="overflow-x-auto max-h-96 overflow-y-auto">
          <table className="w-full border-collapse border border-gray-200">
            <thead>
              <tr className="bg-pink-100 text-left">
                <th className="border border-gray-200 px-4 py-2">Document title</th>
                <th className="border border-gray-200 px-4 py-2">Company Name</th>
                <th className="border border-gray-200 px-4 py-2">Department Name</th>
                <th className="border border-gray-200 px-4 py-2">Document Version</th>
                <th className="border border-gray-200 px-4 py-2">Relevancy Score</th>
              </tr>
            </thead>
            <tbody>
              {documentDetails.map((doc, index) => (
                <tr
                  key={index}
                  className={`${selectedRow === index ? "bg-pink-200" : "hover:bg-pink-50"}`}
                >
                  <td className="border border-gray-200 px-4 py-2 flex items-center">
                    <input
                      type="radio"
                      name="document"
                      className="mr-2"
                      checked={selectedRow === index}
                      onChange={() => setSelectedRow(index)}
                    />
                    {doc.data.data.documentTitle}
                  </td>
                  <td className="border border-gray-200 px-4 py-2">{doc.data.data.company.companyName}</td>
                  <td className="border border-gray-200 px-4 py-2">{doc.data.data.department.departmentName}</td>
                  <td className="border border-gray-200 px-4 py-2">{doc.data.data.documentVersion}</td>
                  <td className="border border-gray-200 px-4 py-2">{doc.score}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Buttons */}
        <div className="flex justify-end p-4">
          <button
            type="button"
            className="px-4 py-2 bg-[#B03982] text-white rounded-3xl w-40"
            disabled={selectedRow === null}
            onClick={handleShowResponse}  // Close modal when clicked
          >
            {t("show_response")}
          </button>
        </div>
      </div>
    </div>
  )
}else{
    return (
    <div className="min-h-[85vh] bg-gray-50 flex justify-center items-center">
      <div className="w-full max-w-5xl p-6 rounded-lg">
        {/* Title */}
        <h2 className="text-xl font-bold mb-8 text-center">
         {t("select_document")}
        </h2>
        <p className="text-center text-sm text-gray-500 mb-8">
         {t("select_deocument_desc")}
        </p>

        {/* Table */}
        {/* Table with scroll */}
        <div className="overflow-x-auto max-h-96 overflow-y-auto">
          <table className="w-full border-collapse border border-gray-200">
            <thead>
              <tr className={`bg-pink-100 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>
                <th className="border border-gray-200 px-4 py-2">{t("document_title")}</th>
                <th className="border border-gray-200 px-4 py-2">{t("company_name")}</th>
                <th className="border border-gray-200 px-4 py-2">{t("department_name")}</th>
                <th className="border border-gray-200 px-4 py-2">{t("document_version")}</th>
                <th className="border border-gray-200 px-4 py-2">{t("relevance_score")}</th>
              </tr>
            </thead>
            <tbody>
              {documentDetails.map((doc, index) => (
                <tr
                  key={index}
                  className={`${selectedRow === index ? "bg-pink-200" : "hover:bg-pink-50"}`}
                >
                  <td className="border border-gray-200 px-4 py-2 flex items-center">
                    <input
                      type="radio"
                      name="document"
                      className={`${dir === 'rtl' ? 'ml-2':'mr-2'}`}
                      checked={selectedRow === index}
                      onChange={() => setSelectedRow(index)}
                    />
                    {doc.data.data.documentTitle}
                  </td>
                  <td className="border border-gray-200 px-4 py-2">{doc.data.data.company.companyName}</td>
                  <td className="border border-gray-200 px-4 py-2">{doc.data.data.department.departmentName}</td>
                  <td className="border border-gray-200 px-4 py-2">{doc.data.data.documentVersion}</td>
                  <td className="border border-gray-200 px-4 py-2">{doc.score}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


        {/* Buttons */}
        <div className="flex justify-end p-4">
          <button
            type="button"
            className="px-4 py-2 bg-[#B03982] text-white rounded-3xl w-40"
            disabled={selectedRow === null}
            onClick={handleShowResponse}  // Close modal when clicked
          >
            {t("show_response")}
          </button>
        </div>
      </div>
    </div>
  )

}
};

export default DocumentTypeForm;
